export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8772.4faa8ba4.jpg";